const PLATFORM_SESSION_FAILURE_DETAILS = new Set([
  'not authenticated',
  'invalid token',
  'token has expired',
  'token expired',
  'token has been revoked',
  'could not validate credentials',
  'authentication credentials were not provided',
  'session expired'
])

export const hasAuthorizationHeader = (headers) => {
  if (!headers) return false
  if (typeof Headers !== 'undefined' && headers instanceof Headers) {
    return Boolean(headers.get('Authorization'))
  }
  if (Array.isArray(headers)) {
    return headers.some(([key]) => String(key).toLowerCase() === 'authorization')
  }
  if (typeof headers.get === 'function') {
    return Boolean(headers.get('Authorization'))
  }
  return Object.keys(headers).some((key) => key.toLowerCase() === 'authorization')
}

export const isPlatformSessionFailure = ({ status, requestHeaders, payload }) => {
  if (status !== 401 || !hasAuthorizationHeader(requestHeaders)) return false

  const rawDetail = payload?.detail ?? payload?.message
  if (typeof rawDetail !== 'string') return false

  return PLATFORM_SESSION_FAILURE_DETAILS.has(rawDetail.trim().toLowerCase())
}
